function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
  fill: "#001738"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 7.80469V15.0703L10.0234 15.0469C11.2891 14.5312 12.6719 14.25 14.0547 14.25H14.5V6.75H14.0547C13.0703 6.75 12.0859 6.9375 11.1719 7.33594C10.7734 7.5 10.375 7.66406 10 7.80469ZM9.41406 5.95312L10 6.1875L10.5859 5.95312C11.6875 5.48438 12.8594 5.25 14.0547 5.25H14.875C15.5078 5.25 16 5.76562 16 6.375V14.625C16 15.2578 15.5078 15.75 14.875 15.75H14.0547C12.8594 15.75 11.6875 15.9844 10.5859 16.4531L10.2812 16.5703C10.0938 16.6406 9.90625 16.6406 9.71875 16.5703L9.41406 16.4531C8.3125 15.9844 7.14062 15.75 5.94531 15.75H5.125C4.51562 15.75 4 15.2578 4 14.625V6.375C4 5.76562 4.51562 5.25 5.125 5.25H5.94531C7.14062 5.25 8.3125 5.48438 9.41406 5.95312Z",
  fill: "white"
});

function SvgDarkIndiCourses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkIndiCourses);
export default __webpack_public_path__ + "static/media/dark-indi-courses.7afdcfbc.svg";
export { ForwardRef as ReactComponent };